import { render, staticRenderFns } from "./OpenCV.vue?vue&type=template&id=a8f257da"
import script from "./OpenCV.vue?vue&type=script&lang=js"
export * from "./OpenCV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports